import React from "react";
import { useHistory } from "react-router-dom";
import packages from "../../data/OurPackagesSection/packagesSection.json";
import "../../assets/scss/components/_ourpackagessection.scss";

const OurPackagesSection = () => {
  const history = useHistory();

  const goToDetails = (slug) => {
    history.push(`/packages/${slug}`);
  };

  return (
    <section className="our-packages">
      {/* HEADER */}
      <div className="our-packages__header">
        <h2>Our Packages</h2>

        <div className="our-packages__sort">
          <span>Sort by</span>
          <select>
            <option>Bengaluru</option>
          </select>
        </div>
      </div>

      {/* GRID */}
      <div className="our-packages__grid">
        {packages.map((item) => (
          <div
            key={item.slug}
            className="our-packages__card"
            onClick={() => goToDetails(item.slug)}
          >
            <img
              src={require(`../../assets/img${item.image}`)}
              alt={item.title}
            />{" "}
            <h3>{item.title}</h3>
            {/* BUTTON */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                goToDetails(item.slug);
              }}
            >
              Read More
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurPackagesSection;
